import { gettext } from '@eventbrite/i18n';
import React from 'react';
import genericOne from '../../../../static/images/generic/generic_1.jpg';
import { CATEGORY_CONTENT_MAP } from '../../constants';
import { useLocation } from '../../hooks/queries/location';
import { CategoryBrowseDateFilter } from '../CategoryBrowseDateFilter';
import { CategoryBrowseLocationAutocomplete } from '../CategoryBrowseLocationAutocomplete';
import './NightlifeHeaderContainer.scss';

interface NightlifeHeaderContainerProps {
    activeCategory: string;
    locale: string;
}

export const NightlifeHeaderContainer: React.FunctionComponent<
    NightlifeHeaderContainerProps
> = (props) => {
    const { data: locationData } = useLocation();
    const { activeCategory } = props;
    const [fallbackImage] = React.useState(genericOne);

    const headerStaticContent = CATEGORY_CONTENT_MAP[activeCategory];

    //Get header text content
    const subTitle = gettext(
        'Electrify your nights with parties, music, comedy, and more.',
    );

    const mainHeader = gettext('%(activeTagName)s', {
        activeTagName: headerStaticContent.title,
    });
    const titleLocation = locationData?.currentPlaceParent
        ? gettext('in %(city)s, %(region)s', {
              city: locationData?.currentPlace,
              region: locationData?.currentPlaceParent,
          })
        : gettext('in %(city)s', { city: locationData?.currentPlace });

    const locationText = locationData?.isOnline
        ? gettext('Online')
        : titleLocation;

    const imageAltText = `${mainHeader} ${locationText}`;
    return (
        <>
            <div className="nightlife--header-container">
                <div className="nightlife--header">
                    <div className="nightlife--header-text">
                        <div className="nightlife--header-text__wrapper">
                            <h1
                                className="nightlife__header--content"
                                style={{
                                    color: 'var(--color-mood-edgy-edgy-purple-100, #ede9f5)',
                                }}
                            >
                                <span className="nightlife--main-header">
                                    {mainHeader}
                                </span>
                                <span className="nightlife--location-text">
                                    {locationText}
                                </span>
                            </h1>
                            <p className="nightlife--subtitle">
                                {headerStaticContent?.subtitle ? subTitle : ''}
                            </p>
                            <section className="nightlife__filters">
                                <CategoryBrowseLocationAutocomplete />
                                <CategoryBrowseDateFilter
                                    locale={props.locale}
                                />
                            </section>
                        </div>
                    </div>
                    <aside className="nightlife--header-image">
                        <img
                            //HTML Img Definition doesnt support fetchpriority but it
                            //is supported in chrome and edge with broader support coming
                            //https://caniuse.com/mdn-html_elements_img_fetchpriority
                            //eslint-disable-next-line
                            //@ts-ignore
                            fetchpriority="high"
                            className="full-width-img"
                            loading="eager"
                            src={headerStaticContent.imageUrl || fallbackImage}
                            alt={
                                imageAltText?.toString() ||
                                gettext('Category browse').toString()
                            }
                        />
                    </aside>
                </div>
            </div>
        </>
    );
};
